import { defineAsyncComponent } from 'vue'
export default {
  admin: defineAsyncComponent(() => import("/app/apps/frontend/layouts/admin.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/app/apps/frontend/layouts/default.vue").then(m => m.default || m)),
  marketing: defineAsyncComponent(() => import("/app/apps/frontend/layouts/marketing.vue").then(m => m.default || m)),
  platform: defineAsyncComponent(() => import("/app/apps/frontend/layouts/platform.vue").then(m => m.default || m))
}